import request from "@/axios/index";
export function selectPrint(params) {
  return request({
    url: "/sys/report",
    method: "get",
    params
  })
}
export function editPrint(id, data) {
  return request({
    url: `/sys/report/${id}`,
    method: "put",
    data
  })
}

export function addPrint(data) {
  return request({
    url: `/sys/report`,
    method: "post",
    data
  })
}

export function deletePrint(id) {
  return request({
    url: `/sys/report/${id}`,
    method: "delete"
  })
}

export function deleteAllPrint(data) {
  return request({
    url: `/sys/report`,
    method: "delete",
    data
  })
}

export function downLoadPrint(data) {
  return request({
    url: `/sys/report/download`,
    method: "post",
    responseType: 'blob',
    data
  })
}


